import React from 'react';
import { ArticleContactWrapper, ArticleEnumeration, ArticleTextOnly, Headline } from '../../components/article/article.component';
import { ImageContainer, ImpressumContactAndLogoWrapper, ImpressumLogoContainer, ImpressumPageContainer, ImpressumWrapper } from './impressum.styles';
import tusImg from '../../assets/header/tus-scharnhorst3.png';

const gridLayout = {
  gap: "8px",
  space1: "max-content",
  space2: "auto",
  indexSpace: 0
}

const ImpressumPage = () => (
  <ImpressumPageContainer>
    <Headline text="Impressum"/>
    <ImpressumWrapper>
      <ImpressumContactAndLogoWrapper>
        <ArticleContactWrapper
          title="Angaben gemäß § 5 TMG"
          textArr={[
            {id:1,text:"TuS Scharnhorst 1895/1926 e.V."},
            {id:2,text:""},
            {id:3,text:"Gleiwitzstraße 281"},
            {id:4,text:""},
            {id:5,text:"44328 Dortmund"},
          ]}
          gridSpaceIndex={gridLayout.indexSpace} gridSpace1={gridLayout.space1} gridSpace2={gridLayout.space2} gridGap={gridLayout.gap}
        />
        <ImpressumLogoContainer>
            <ImageContainer src={tusImg}/>
        </ImpressumLogoContainer>
      </ImpressumContactAndLogoWrapper>
      <ArticleEnumeration
        title="Vertreten durch:"
        textArr={[
          {id:1,text:"1. Vorsitzender Bilal Abaraghoin"},
        ]}   
      />
      <ArticleContactWrapper
        title="Kontakt"
        textArr={[
          {id:1,text:"Telefon:"},
          {id:2,text:"0231/5899143"},
          {id:3,text:"Fax:"},
          {id:4,text:"0231/22278480"},
          {id:5,text:"E-Mail:"},
          {id:6,text:"tusscharnhorst@dokom.net"},
        ]}
        gridSpaceIndex={gridLayout.indexSpace} gridSpace1={gridLayout.space1} gridSpace2={gridLayout.space2} gridGap={gridLayout.gap}
      />
      <ArticleContactWrapper

        title="Vereinsregister"
        textArr={[
          {id:1,text:"Registergericht:"},
          {id:2,text:"Amtsgericht Dortmund"},
          {id:3,text:"Registernummer:"},
          {id:4,text:"VR 2108"},
        ]}
        gridSpaceIndex={gridLayout.indexSpace} gridSpace1={gridLayout.space1} gridSpace2={gridLayout.space2} gridGap={gridLayout.gap}
      />
      <ArticleContactWrapper
        title="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:"
        textArr={[
          {id:1,text:"Bogensportabteilung"},
          {id:2,text:""},
          {id:3,text:"Uwe Niehaus"},
          {id:4,text:""},
          {id:5,text:"Unnaerstraße 34"},
          {id:6,text:""},
          {id:7,text:"59439 Holzwickede"},
          {id:8,text:""},
          {id:9,text:"E-Mail: kontakt@bogensport-dortmund.de"},
          {id:10,text:""},
        ]}
        gridSpaceIndex={gridLayout.indexSpace} gridSpace1={gridLayout.space1} gridSpace2={gridLayout.space2} gridGap={gridLayout.gap}
      />
    </ImpressumWrapper>
    
    <ArticleTextOnly 
      title="Haftung für Inhalte"
      text="Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen."    
    />
    <ArticleTextOnly 
      title="Haftung für Links"
      text="Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen."    
    />
    <ArticleTextOnly 
      title="Urheberrecht"
      text="Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen."    
    />
  </ImpressumPageContainer>
);

export default ImpressumPage;